import React from 'react';

const TermsOfService = () => {
    return (
        <div className="container mx-auto px-9 relative flex flex-col items-center gap-2.5 md:border-2 py-6 rounded-3xl min-h-[100%] mb-12">
            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>Terms of Service for Vortexi</p>
            <p>Effective date: 10.10.2024</p>

            <p>
                Welcome to Vortexi! By using our Chrome extension, you agree to comply with and be bound by the following terms and conditions. If you do not agree with any part of these terms, please do not use our service.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>1. Acceptance of Terms</p>
            <p>
                By accessing or using the Vortexi extension, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service and our Privacy Policy.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>2. Description of Service</p>
            <p>
                Vortexi is a Chrome extension designed to facilitate the composition and sending of emails via Gmail and Outlook. It offers features such as customizable email templates, recipient management, and a user-friendly interface for quick email sending.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>3. User Responsibilities</p>
            <p>
                You agree to use the Vortexi extension only for lawful purposes and in a manner that does not infringe on the rights of any third party. You are responsible for all activities that occur under your account.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>4. Account Security</p>
            <p>
                You are responsible for maintaining the confidentiality of your account credentials and for any activities that occur under your account. If you suspect any unauthorized use of your account, you must notify us immediately.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>5. Data Privacy</p>
            <p>
                Your use of Vortexi is also governed by our Privacy Policy, which explains how we collect, use, and protect your information. By using the extension, you consent to our collection and use of your information as described in the Privacy Policy.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>6. Limitation of Liability</p>
            <p>
                In no event shall Vortexi, its developers, or affiliates be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use of the extension or your inability to use it.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>7. Modifications to the Service</p>
            <p>
                We reserve the right to modify or discontinue, temporarily or permanently, the Vortexi extension or any part of it with or without notice. You agree that we shall not be liable to you or any third party for any modification or discontinuation of the service.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>8. Termination</p>
            <p>
                We may terminate or suspend your access to the Vortexi extension immediately, without prior notice or liability, for any reason, including but not limited to a breach of these Terms of Service.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>9. Changes to These Terms</p>
            <p>
                We may update our Terms of Service from time to time. We will notify you of any changes by posting the new Terms of Service on this page. You are advised to review this page periodically for any changes. Changes to these Terms are effective when they are posted on this page.
            </p>

            <p className='text-2xl md:text-3xl text-center font-montserrat-bold'>10. Contact Us</p>
            <p>
                If you have any questions about these Terms of Service, please contact us at vortexiai.business@gmail.com.
            </p>
        </div>
    );
};

export default TermsOfService;